import React, { Component } from 'react';
import {CKEditor} from 'ckeditor4-react';
import './cw-custom-ck-editor.scss';
import URL from '../../../apis/url';

class CWCustomCKEditor extends Component {
    state = {};
    config = {};

    constructor(props) {
        super(props)
        CKEditor.editorUrl = process.env.PUBLIC_URL + "/ckeditor/ckeditor.js";

        this.config = {
            extraPlugins: `justify,colorbutton,colordialog,${this.props.autoGrow ? 'autogrow' : ''}`,
            mathJaxLib: 'http://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
            toolbar: this.props.toolbar ? this.props.toolbar : null,
            toolbarLocation: this.props.location ? this.props.location : 'top',
            removePlugins: 'elementspath',
            height: this.props.height ? this.props.height : 160,
            pasteFromWordRemoveFontStyles: true,
            pasteFromWordRemoveStyles: true,
            disallowedContent: 'br;span',
            extraAllowedContent: 'img[*]{*}(*)',
            baseUrl: URL.BASE_URL
            //forcePasteAsPlainText: true
        }
        if (this.props.autoGrow) {
            this.config.autoGrow_minHeight = this.props.height ? this.props.height : 160;
            this.config.autoGrow_onStartup = true;
            this.config.autoGrow_bottomSpace = 15;
        }
        if (this.props.disableResize)
            this.config.resize_enabled = false;
            
        if (this.props.placeholder)
            this.config.placeholder = this.props.placeholder;
    }

    render() {
        return (
            <CKEditor
                config={this.config}
                type={this.props.type ? this.props.type : 'classic'}
                initData={this.props.content}
                onChange={(event) => {
                    const data = event.editor.getData();
                    this.props.onChange(data, event);
                }}
                onPaste={(event) => this.props.onPaste && this.props.onPaste(event)}
            />
        );
    }
}

export default CWCustomCKEditor;


/** Math jax lib
 * http://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML
 */
